import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PascalChove from '@/views/PascalChove.vue'
import Peintures from '@/views/Peintures.vue'
import Dessins from '@/views/Dessins.vue'
import Sculptures from '@/views/Sculptures.vue'
import Videos from '@/views/Videos.vue'
import Contact from '@/views/Contact.vue'
import NotFound from '@/views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/pascal-chove',
    name: 'pascal-chove',
    component: PascalChove,
  },
  {
    path: '/peintures',
    name: 'peintures',
    component: Peintures,
  },
  {
    path: '/dessins',
    name: 'dessins',
    component: Dessins,
  },
  {
    path: '/sculptures',
    name: 'sculptures',
    component: Sculptures,
  },
  {
    path: '/videos',
    name: 'videos',
    component: Videos,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
  { path: '/:catchAll(.*)', name: 'NotFound', component: NotFound },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
